import { Lock } from 'lucide-react';

import SecurityLayout from '../../components/security/SecurityLayout';

import { SUPPORT } from '../../config/support';

export default function PendingPage() {
  return (
    <SecurityLayout
      variant="pending"
      icon={Lock}
      title="Acesso pendente"
      description="Sua conta foi criada com sucesso. Entre em contato com nossa equipe para concluir a liberação do acesso à plataforma."
      buttonText="Solicitar acesso"
      buttonHref={SUPPORT.whatsapp}
      footerText="Após a validação, seu acesso será liberado pela equipe Nexora."
    />
  );
}